export enum Permission {
  ConfigurableProductsModify = 'configurable_products.modify',
  CatalogProductsView = 'catalog_products.view',
}
